export default function populateDebitCardPaymentOption(option, data) {
  if (typeof data.token !== 'undefined') {
    option.token = data.token; // eslint-disable-line no-param-reassign
  }

  if (data.updateOption) {
    option.details.expirationMonth = data.updateOption.expirationMonth; // eslint-disable-line no-param-reassign
    option.details.expirationYear = data.updateOption.expirationYear; // eslint-disable-line no-param-reassign
  }

  if (data.address) {
    option.details.postalCode = data.address.postalCode; // eslint-disable-line no-param-reassign
  }

  return option;
}
